import { array } from 'fp-ts';
import {
    EnterpriseProfilePrivileges,
    EnterpriseProfilePrivilegesEnumNames,
    EnterpriseProfilePrivilegesEnumValue,
    EnterpriseProfilePrivilegesFlagNames,
} from '@mews-commander/legacy-data-structures';

type PrivilegeFlagToEnumMap = {
    [key in EnterpriseProfilePrivilegesFlagNames]: EnterpriseProfilePrivilegesEnumValue;
};

export const privilegeFlagToEnumMap: PrivilegeFlagToEnumMap = {
    configureEnterprise: EnterpriseProfilePrivileges.ConfigureEnterprise,
    manageServices: EnterpriseProfilePrivileges.ManageServices,
    manageResourceCategories: EnterpriseProfilePrivileges.ManageResourceCategories,
    manageProducts: EnterpriseProfilePrivileges.ManageProducts,
    manageBusinessSegments: EnterpriseProfilePrivileges.ManageBusinessSegments,
    manageRateGroups: EnterpriseProfilePrivileges.ManageRateGroups,
    manageProductRules: EnterpriseProfilePrivileges.ManageProductRules,
    manageRates: EnterpriseProfilePrivileges.ManageRates,
    manageRestrictions: EnterpriseProfilePrivileges.ManageRestrictions,
    manageSellLimits: EnterpriseProfilePrivileges.ManageSellLimits,
    manageServiceConfigurations: EnterpriseProfilePrivileges.ManageServiceConfigurations,
    manageSpaces: EnterpriseProfilePrivileges.ManageSpaces,
    overrideRestrictions: EnterpriseProfilePrivileges.OverrideRestrictions,
    manageCompanyContracts: EnterpriseProfilePrivileges.ManageCompanyContracts,
    manageReservations: EnterpriseProfilePrivileges.ManageReservations,
    performHousekeeping: EnterpriseProfilePrivileges.PerformHousekeeping,
    issueInvoices: EnterpriseProfilePrivileges.IssueInvoices,
    overbookServices: EnterpriseProfilePrivileges.OverbookServices,
    manageProfiles: EnterpriseProfilePrivileges.ManageProfiles,
    chargeCardsOnline: EnterpriseProfilePrivileges.ChargeCardsOnline,
    manageInvoiceability: EnterpriseProfilePrivileges.ManageInvoiceability,
    viewCustomerData: EnterpriseProfilePrivileges.ViewCustomerData,
    viewCompanyData: EnterpriseProfilePrivileges.ViewCompanyData,
    viewSensitiveReports: EnterpriseProfilePrivileges.ViewSensitiveReports,
    manageAvailability: EnterpriseProfilePrivileges.ManageAvailability,
    manageAccountingCategories: EnterpriseProfilePrivileges.ManageAccountingCategories,
    manageAccountingConfiguration: EnterpriseProfilePrivileges.ManageAccountingConfiguration,
    manageCounters: EnterpriseProfilePrivileges.ManageCounters,
    manageDepartments: EnterpriseProfilePrivileges.ManageDepartments,
    manageOutlets: EnterpriseProfilePrivileges.ManageOutlets,
    rebateItems: EnterpriseProfilePrivileges.RebateItems,
    manageAvailabilityBlockRates: EnterpriseProfilePrivileges.ManageAvailabilityBlockRates,
    manageAccounts: EnterpriseProfilePrivileges.ManageAccounts,
    manageLoyaltyMemberships: EnterpriseProfilePrivileges.ManageLoyaltyMemberships,
    manageMailQueue: EnterpriseProfilePrivileges.ManageMailQueue,
    overrideRatePrice: EnterpriseProfilePrivileges.OverrideRatePrice,
    requestInstantPayouts: EnterpriseProfilePrivileges.RequestInstantPayouts,
    managePaymentAndCancellationPolicies: EnterpriseProfilePrivileges.ManagePaymentAndCancellationPolicies,
    clearCustomerData: EnterpriseProfilePrivileges.ClearCustomerData,
    manageMailTemplates: EnterpriseProfilePrivileges.ManageMailTemplates,
};

export const mapPrivilegesFlagsToEnums = array.map<
    EnterpriseProfilePrivilegesFlagNames,
    EnterpriseProfilePrivilegesEnumValue
>((privilegeFlagName) => privilegeFlagToEnumMap[privilegeFlagName]);

const privilegesValues = EnterpriseProfilePrivileges.enumValues.map(({ value }) => value);

export const isPrivilegeValue = (val: unknown): val is EnterpriseProfilePrivilegesEnumNames =>
    typeof val === 'string' && privilegesValues.includes(val as EnterpriseProfilePrivilegesEnumNames);
